"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var PathUtil = __importStar(require("../../Utils/PathUtil"));
var reconnect_js_1 = require("reconnect.js");
var query_string_1 = __importDefault(require("query-string"));
var NavUrl_1 = __importDefault(require("../../Utils/NavUrl"));
function NavLink(props) {
  var to = props.to,
    _a = props.loading,
    loading = _a === void 0 ? false : _a,
    className = props.className,
    style = props.style,
    extraStyle = props.extraStyle,
    _b = props.preventDefaultExtNav,
    preventDefaultExtNav = _b === void 0 ? false : _b,
    rest = __rest(props, ["to", "loading", "className", "style", "extraStyle", "preventDefaultExtNav"]);
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var extLinkPattern = /http/;
  if (extLinkPattern.test(to) && !preventDefaultExtNav) {
    return react_1.default.createElement("a", __assign({
      href: to,
      target: "_blank",
      rel: "noreferrer",
      className: className,
      style: style || extraStyle || {}
    }, rest), props.children);
  }
  return react_1.default.createElement("a", __assign({
    href: PathUtil.normalizedRoute(to),
    onClick: function onClick(evt) {
      evt.preventDefault();
      var _nextUrl = to;
      var _a = query_string_1.default.parseUrl(_nextUrl),
        url = _a.url,
        query = _a.query;
      var navUrl = new NavUrl_1.default(url, query);
      AppActions.navigate(navUrl, {
        loading: loading
      });
    },
    className: className,
    style: style || extraStyle || {}
  }, rest), props.children);
}
exports.default = NavLink;